import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SingleResponseModel } from '../../common/models/single-response.model';
import { InformeBookingResponse, FiltroInformesBooking } from '../models/booking-reports.model';

/**
 * Service for getting Bookings reports
 * Handles report operations (Sales, Employees, Operational)
 */
@Injectable({
  providedIn: 'root'
})
export class BookingReportsService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Gets booking reports with filters
   * @param filter Filter criteria (required: desde, hasta; optional: centroTrabajoId, empleadoId, servicioId, estadoIds)
   */
  getBookingReports(filter: FiltroInformesBooking): Observable<SingleResponseModel<InformeBookingResponse>> {
    let params = new HttpParams()
      .set('from', filter.desde)
      .set('to', filter.hasta);

    if (filter.centroTrabajoId) {
      params = params.set('locationId', filter.centroTrabajoId);
    }
    if (filter.empleadoId) {
      params = params.set('staffId', filter.empleadoId);
    }
    if (filter.servicioId) {
      params = params.set('conceptId', filter.servicioId);
    }
    if (filter.estadoIds && filter.estadoIds.length > 0) {
      filter.estadoIds.forEach(id => {
        params = params.append('statusIds', id.toString());
      });
    }

    return this.http.get<SingleResponseModel<InformeBookingResponse>>(
      `${this.apiUrl}/api/v2/booking/reports`,
      { params }
    );
  }

  exportBookingReportsExcel(filter: FiltroInformesBooking): Observable<HttpResponse<Blob>> {
    let params = new HttpParams()
      .set('from', filter.desde)
      .set('to', filter.hasta);

    if (filter.centroTrabajoId) {
      params = params.set('locationId', filter.centroTrabajoId);
    }
    if (filter.empleadoId) {
      params = params.set('staffId', filter.empleadoId);
    }
    if (filter.servicioId) {
      params = params.set('conceptId', filter.servicioId);
    }
    if (filter.estadoIds && filter.estadoIds.length > 0) {
      filter.estadoIds.forEach(id => {
        params = params.append('statusIds', id.toString());
      });
    }

    return this.http.get(`${this.apiUrl}/api/v2/booking/reports/export-excel`, {
      params,
      observe: 'response',
      responseType: 'blob'
    });
  }
}
